
export default function MaintenanceHeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-green-50 to-blue-50 py-20 lg:py-32 overflow-hidden">
      {/* 背景画像 */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/934c4d4263516e1cbdaadc4a1c6c9242.webp"
          alt="ドローン整備の様子"
          className="w-full h-full object-cover object-top opacity-20"
          loading="eager"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/25 to-white/5"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            点検・整備<br />
            <span className="text-[#2A6041]">サービス</span>
          </h1>
          
          <p className="text-xl lg:text-2xl text-gray-700 mb-8 font-medium">
            DJI認定整備士が、あなたの大切な機体を守ります
          </p>
          
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl">
            IDS教習所グループでは、佐賀・川副・鹿児島の全3拠点にDJI認定整備士が在籍。DJI整備項目に準拠した年次点検から、万が一の緊急修理まで、グループ全体でお客様の安全飛行をサポートします。IDS佐賀教習所はDJI推薦修理センターに認定されており、他社購入機のサポートも可能です。
          </p>
        </div>
      </div>
    </section>
  );
}
